import { combine } from 'react-hooks-combine'

import FlipCardComponent from './component'

export const FlipCard = combine()(FlipCardComponent)
